import { useEffect, useRef } from 'react';

/**
 * Prompts before the page unloads while `isDirty()` reports unsaved
 * changes. The callback is re-read every render through a ref, so callers
 * pass a plain closure over current state.
 */
export function useUnsavedChangesGuard(isDirty: () => boolean) {
   const isDirtyRef = useRef(isDirty);
   useEffect(() => {
      isDirtyRef.current = isDirty;
   });

   useEffect(() => {
      const warnBeforeLeaving = (event: BeforeUnloadEvent) => {
         if (isDirtyRef.current()) {
            event.preventDefault();
         }
      };
      window.addEventListener('beforeunload', warnBeforeLeaving);
      return () => window.removeEventListener('beforeunload', warnBeforeLeaving);
   }, []);
}
